import { useEffect, useState } from 'react';

export const useCurrencyConverter = ({
  from = 'MXN',
  to = 'USD',
  useLiveRate = true,
  fallbackRate = 18,
} = {}) => {
  
  const [rate, setRate] = useState(fallbackRate);
  const [loading, setLoading] = useState(useLiveRate);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!useLiveRate) return;
    setLoading(true);
    fetch(`https://api.exchangerate.host/latest?base=${from}&symbols=${to}`)
      .then((res) => res.json())
      .then((data) => {
        const fetchedRate = data?.rates?.[to];
        if (fetchedRate) {
          setRate(fetchedRate);
        } else {
          throw new Error('Invalid rate');
        }
      })
      .catch((err) => {
        setError(err.message || 'Unknown error');
        setRate(fallbackRate);
      })
      .finally(() => setLoading(false));
  }, [from, to, useLiveRate, fallbackRate]);

  const convert = (amount) => {
    return Number(amount) / rate;
  };

  const convertBack = (amount) => {
    return Number(amount) * rate;
  };

  return {
    convert,
    convertBack,
    rate,
    loading,
    error,
  };
};
